<template>
  <v-card flat max-width="70%" min-width="50%">
    <v-card-text>
      <!-- По умолчанию -->
      <v-list>
        <v-list-item>
          <v-list-item-title class="text-h6 text-wrap">
            <v-fade-transition>
              <div v-if="!defaultUnitRidOk" class="red--text">
                Не указана единица измерения по умолчанию
                <br />
              </div>
            </v-fade-transition>
            Ед. измерения по умолчанию
          </v-list-item-title>
          <v-list-item-subtitle>
            <v-select
              :items="unitSelectOptions"
              item-text="name"
              item-value="rid"
              :value="defaultVal"
              clearable
              @change="(e) => selectDefault(e)"
            >
              <template v-slot:item="{ item }">
                <v-card-text v-if="item.name != 'Создать'">
                  {{ item.name }}
                </v-card-text>
                <v-card-text v-else @click.stop="create(null)">
                  <v-icon>mdi-plus</v-icon>Создать новую
                </v-card-text>
              </template>
            </v-select>
          </v-list-item-subtitle>
        </v-list-item>
      </v-list>
      <v-divider />
      <!-- Из файла -->
      <v-list>
        <!-- Заголовок -->
        <v-list-item>
          <v-list-item-title class="black--text text-h6 text-wrap">
            Ед. измерения из файла
          </v-list-item-title>
          <v-list-item-subtitle class="black--text text-h6">
            Ед. измерения SH
          </v-list-item-subtitle>
        </v-list-item>
        <v-list-item
          v-for="(unit, i) in unitListItems"
          :key="i"
          :style="`background-color: ${i % 2 == 1 ? '' : '#F5F5F5'};`"
        >
          <v-list-item-title>
            {{ unit.name }}
          </v-list-item-title>
          <v-list-item-subtitle>
            <v-select
              :items="unitSelectOptions"
              item-text="name"
              item-value="rid"
              :value="unit.rid"
              clearable
              @change="(e) => select(e, i)"
            >
              <template v-slot:item="{ item }">
                <v-card-text v-if="item.name != 'Создать'">
                  {{ item.name }}
                </v-card-text>
                <v-card-text v-else @click.stop="create(i)">
                  <v-icon>mdi-plus</v-icon>Создать новую
                </v-card-text>
              </template>
            </v-select>
          </v-list-item-subtitle>
        </v-list-item>
      </v-list>
    </v-card-text>
    <!-- Создание -->
    <v-dialog v-model="dialog" max-width="50%">
      <v-card>
        <v-card-title> Создание новой ед. измерения в StoreHouse </v-card-title>
        <v-form @submit.prevent="createNewUnit" v-model="valid">
          <v-card-text>
            <v-select
              :items="SHUnitsGroups"
              item-text="name"
              item-value="rid"
              label="Группа ед. измерений"
              return-object
              v-model="group"
            />
            <v-banner
              color="warning"
              :icon="base == null ? `mdi-alert` : ''"
              class="mb-5 black--text"
              outlined
              dark
            >
              Базовая ед. измерения: {{ base == null ? "Не выбрана" : base }}
            </v-banner>

            <v-text-field
              label="Название новой ед."
              v-model="name"
              @input="(e) => (name = e)"
              :rules="[(v) => !!v || `Необходимое поле`]"
              required
            />
            <v-text-field
              label="Коэффициент относительно базовой ед."
              type="number"
              min="0.0001"
              step="0.0001"
              v-model="coeff"
              required
              @input="(e) => updateCoeff(parseFloat(e == `` ? 0 : e))"
            />
          </v-card-text>
          <v-card-actions>
            <v-btn @click="dialog = false" outlined color="error" type="reset">
              ЗАКРЫТЬ
            </v-btn>
            <v-spacer />
            <v-btn
              :disabled="!(base != null && name != '' && !isLoading)"
              @click="createNewUnit"
              :loading="isLoading"
              color="primary"
              type="submit"
            >
              СОЗДАТЬ
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data: () => ({
    base: null,
    coeff: 0.0001,
    group: null,
    name: "",
    isLoading: false,
    dialog: false,
    valid: false,
    unitListItems: [],
    unitSelectOptions: [],
    defaultVal: null,
    createForIdx: null,
    changed: false,
  }),
  computed: {
    ...mapGetters([
      "units",
      "SHUnits",
      "SHUnitsGroups",
      "defaultUnitRidOk",
      "uploadOptions",
    ]),
    unitOk() {
      return this.defaultUnitRidOk;
    },
  },
  watch: {
    group(newGroup) {
      for (const unitIdx in newGroup.units) {
        if (newGroup.units[unitIdx].isBase) {
          this.base = newGroup.units[unitIdx].name;
          break;
        }
      }
    },
    unitOk(newVal) {
      this.$emit("cant-continue", !newVal);
    },
  },
  methods: {
    ...mapActions([
      "createUnit",
      "updateUnitRid",
      "updateUploadOption",
      "parseUnits",
      "saveUnits",
      "loadUnits",
    ]),
    changeGroup(g) {
      this.group = g;
    },
    updateCoeff(c) {
      this.coeff = c;
    },
    async createNewUnit() {
      this.isLoading = true;
      let unit = await this.createUnit({
        name: this.name,
        coeff: this.coeff,
        group_rid: this.group.rid,
      });
      this.isLoading = false;
      this.name = "";
      this.dialog = false;
      if (unit != null) {
        this.unitSelectOptions.unshift(unit);
        if (this.createForIdx != null) {
          this.select(unit.rid, this.createForIdx);
        } else {
          this.selectDefault(unit.rid);
        }
      }
      this.createForIdx = null;
    },
    create(idx) {
      if (idx != null) {
        this.name = this.unitListItems[idx].name;
      }
      this.createForIdx = idx;
      this.dialog = true;
    },
    select(val, idx) {
      this.changed = true;
      this.updateUnitRid({ val, idx });
    },
    selectDefault(val) {
      this.defaultVal = val;
      this.updateUploadOption({ key: `defaultUnitRid`, val });
    },
  },
  async created() {
    this.$emit("loading-start", "Парсинг ед. измерения");
    await this.parseUnits();
    let shUnits = [];
    for (const unit of this.SHUnits) shUnits.push(unit);
    shUnits.push({ name: "Создать", rid: undefined, func: this.create });

    let unitsList = [];
    for (const unit of this.units) unitsList.push(unit);

    this.unitListItems = unitsList;
    this.unitSelectOptions = shUnits;
    this.defaultVal = this.uploadOptions.defaultUnitRid;
  },
  async beforeMount() {
    this.$emit("loading-start", "Загрузка ед. измерения");
    await this.$store.dispatch("loadUnits");
    this.$emit("loading-stop");
  },
  mounted() {
    if (!this.defaultUnitRidOk) this.$emit("cant-continue", true);
    else {
      this.$emit("cant-continue", false);
    }
  },
  beforeDestroy() {
    this.$emit("loading-start", "Сохранение ед. измерения");
    this.saveUnits();
    this.$emit("loading-stop", "Сохранение ед. измерения");
  },
};
</script>